import styled from 'styled-components';

//theme
import { homeColor } from '@/theme/ai';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//components
import { Section } from '@/containers-ai/SectionHeading';

export const WorkflowSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const PodStage = styled.div`
  border: 1px solid rgba(20, 214, 77, 0.16);
  border-radius: 20px;
  padding: 22px 22px 18px;
  margin-top: 34px;
  background:
    linear-gradient(
      180deg,
      rgba(0, 215, 215, 0.06) 0%,
      rgba(0, 215, 215, 0) 55%
    ),
    rgb(7, 24, 24);
`;

export const PodHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
`;

export const PodTitle = styled.span`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 12px;
  letter-spacing: 0.06em;
`;

export const PodChip = styled.span`
  font-family: ${getToken('font-family-default')};
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 4px 11px;
  border-radius: 20px;
  white-space: nowrap;

  ${(props) =>
    props.$done
      ? `
    color: ${homeColor.green};
    background: rgba(20, 214, 77, 0.14);
  `
      : `
    color: ${homeColor.amber};
    background: rgba(245, 181, 68, 0.12);
  `}
`;

export const GraphWrap = styled.div`
  overflow-x: auto;
  margin: 12px 0;
`;

export const GraphSvg = styled.svg`
  width: 100%;
  height: auto;
  display: block;
  max-width: 1020px;
  margin: 0 auto;
`;

export const NodeGroup = styled.g`
  rect {
    transition:
      stroke 0.35s,
      filter 0.35s;
  }

  ${(props) =>
    props.$agent &&
    `
    rect { stroke: url(#${props.$gradId}); stroke-width: 2; }
  `}

  ${(props) =>
    props.$active &&
    `
    rect { stroke: #14D64D; filter: drop-shadow(0 0 7px rgba(20, 214, 77, .55)); }
  `}

  @media (prefers-reduced-motion: reduce) {
    rect {
      transition: none;
    }
  }
`;

export const EdgePath = styled.path`
  stroke: #2a5b60;
  fill: none;
  stroke-width: 1.5;
  transition:
    stroke 0.35s,
    stroke-width 0.35s;

  ${(props) => props.$sub && `stroke-dasharray: 4 4;`}
  ${(props) => props.$dim && `opacity: .55;`}
  ${(props) =>
    props.$active &&
    `
    stroke: #14D64D;
    stroke-width: 2.2;
  `}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const EdgeLabel = styled.text`
  font-family: ${getToken('font-family-default')};
  font-size: 9px;
  letter-spacing: 0.05em;
  fill: ${homeColor.muted2};
`;

export const PodFoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  font-family: ${getToken('font-family-default')};
  font-size: 10px;
  color: ${homeColor.muted2};
`;

export const ReplayButton = styled.button`
  font-family: ${getToken('font-family-default')};
  font-size: 10px;
  letter-spacing: 0.06em;
  color: ${homeColor.green};
  background: transparent;
  border: 1px solid ${homeColor.line2};
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;

  &:hover {
    background: rgba(20, 214, 77, 0.08);
  }
`;
